// src/KlineService.js
import axios from 'axios';
const urlParams = new URLSearchParams(window.location.search);
const BASE_URL = urlParams.get('local') === '1' ? 'http://localhost:8080' : 'https://signal.flaze.ai';

const KlineService = {
  fetchData: async (symbol, exchange, interval, startTime, endTime, setData, setError) => {
    try {
      const response = await axios.get(`${BASE_URL}/klines`, {
        params: {
          symbol: symbol.toUpperCase(),
          exchange: exchange,
          interval: interval.toLowerCase().replace("_", ""),
          startTime: startTime,
          endTime: endTime
        },
        headers: {
          'Accept-Encoding': 'gzip, deflate, br'
        }
      });

      // Split the response data by newline
      const rawData = response.data.trim().split('\n');

      // Parse each line as JSON and transform the data
      const transformedData = rawData.map(line => {
        const item = JSON.parse(line);
        return {
          open: parseFloat(item[1]),
          high: parseFloat(item[2]),
          low: parseFloat(item[3]),
          close: parseFloat(item[4]),
          time: item[0] / 1000  // converting milliseconds to seconds
        };
      });

      setData(transformedData);
    } catch (error) {
      console.error('Error fetching the data', error);
      setError('Error fetching the data');
    }
  }
};

export default KlineService;
